import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './FetchBaseQuery';

export const providerApi = createApi({
   reducerPath: 'providerApi',
   baseQuery: baseQueryWithReauth,
   tagTypes: ['ServiceProvider'],
   endpoints: (builder) => ({
      getProviders: builder.query({
         query: () => ({
            url: '/service',
            method: 'GET',
         }),
         providesTags: ['ServiceProvider'],
      }),

      getProviderById: builder.query({
         query: (id) => `/service/single/${id}`,
         providesTags: (result, error, id) => [{ type: 'ServiceProvider', id }],
      }),

      getProviderListingPagination: builder.query({
         query: (queryParams = {}) => ({
            url: '/service/list',
            method: 'GET',
            ...(queryParams && { params: queryParams }),
         }),
         providesTags: ['ServiceProvider'],
      }),

      createProvider: builder.mutation({
         query: (formData) => ({
            url: '/service/create',
            method: 'POST',
            body: formData,
         }),
         invalidatesTags: ['ServiceProvider'],
      }),

      updateProvider: builder.mutation({
         query: ({ id, formData }) => ({
            url: `/service/update/${id}`,
            method: 'PUT',
            body: formData,
         }),
         invalidatesTags: ['ServiceProvider'],
      }),

      updateProviderContact: builder.mutation({
         query: ({ id, email, phoneNo }) => ({
            url: `/service/contact/${id}`,
            method: 'PATCH',
            body: { email, phoneNo },
         }),
         invalidatesTags: ['ServiceProvider'],
      }),

      deleteProvider: builder.mutation({
         query: (id) => ({
            url: `/service/delete/${id}`,
            method: 'DELETE',
         }),
         invalidatesTags: ['ServiceProvider'],
      }),
   }),
});

export const {
   useGetProvidersQuery,
   useGetProviderByIdQuery,
   useGetProviderListingPaginationQuery,
   useCreateProviderMutation,
   useUpdateProviderMutation,
   useUpdateProviderContactMutation,
   useDeleteProviderMutation,
} = providerApi;
